import { Component, OnInit } from '@angular/core';

import { CustomTitleService } from 'app/shared/service/custom-title/custom-title.service';

@Component({
  selector: 'cc-company-settings',
  templateUrl: './company-settings.component.html',
  styleUrls: ['./company-settings.component.scss'],
})
export class CompanySettingsComponent implements OnInit {
  readonly workspaceSettingTabs = [
    {
      titleCode: 'general',
      routerLink: 'general',
    },
    {
      titleCode: 'branding',
      routerLink: 'branding',
    },
  ];

  readonly sitemateStartSettingTabs = [
    {
      titleCode: 'smsGlobalBilling',
      routerLink: 'global-billing',
    },
    {
      titleCode: 'smsDashpivotBilling',
      routerLink: 'dashpivot-billing',
    },
    {
      titleCode: 'smsSecurity',
      routerLink: 'security',
    },
  ];

  constructor(private readonly customTitleService: CustomTitleService) {}

  ngOnInit() {
    this.customTitleService.setTitle(`Settings - Dashpivot`);
  }
}
